// extracted by mini-css-extract-plugin
export default {"navlink-btn":"NavLinks_navlink-btn__H9xM5"};